import dynamic from 'next/dynamic'
import { type FC } from 'react'

import { Loading } from '../../../../loading'

const DefaultProductSearchResultItemNowDialogContent = dynamic(
  async () =>
    import('./ProductSearchResultItemNowDialogContent').then(
      (mod) => mod.ProductSearchResultItemNowDialogContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)

export const ProductSearchResultItemNowDialogDynamicContent: FC = () => {
  return <DefaultProductSearchResultItemNowDialogContent />
}
